export const nasrCity = {
  landmarks: [
    "شارع عباس العقاد",
    "شارع مكرم عبيد",
    "شارع مصطفى النحاس",
    "طريق النصر",
    "ميدان رابعة العدوية",
    "استاد القاهرة الدولي",
    "الحي السادس والحي السابع",
    "محور NA",
    "حي السفارات"
  ],
  title: "ونش انقاذ مدينة نصر | خدمة فورية بعباس العقاد ومكرم عبيد",
  metaDescription: "تحتاج ونش سيارات في مدينة نصر؟ نقدم لك أسرع خدمة إنقاذ سيارات متواجدة في شارع عباس العقاد ومصطفى النحاس وطريق النصر. اتصل الآن لوصول فوري.",
  intro: `مدينة نصر هي القلب النابض لشرق القاهرة، حيث تتقاطع فيها أهم الطرق التجارية والسكنية مثل شارع عباس العقاد ومكرم عبيد وطريق النصر. الحركة المرورية هنا لا تتوقف، وأي عطل لسيارتك في هذه المحاور المزدحمة يعني تأخيراً كبيراً لك وإرباكاً للمرور. من هنا تأتي أهمية اختيار ونش انقاذ سريع وموثوق داخل مدينة نصر.
  فريقنا متواجد بشكل مكثف لتغطية كافة شوارع وأحياء مدينة نصر، من الحي السادس والسابع وحتى حي السفارات واستاد القاهرة. نحن نعلم أن الأولوية هي لرفع سيارتك بأمان وسرعة من قلب الزحام، ولذلك نوفر أوناشاً مجهزة للتحرك بمرونة في الشوارع المزدحمة لضمان سلامتك وسلامة سيارتك.`,
  highlights: [
    "سرعة الوصول في أوقات الذروة بشوارع مصطفى النحاس وعباس العقاد",
    "أوناش هيدروليكية مؤمنة بالكامل للتعامل مع السيارات الأوتوماتيك والرياضية",
    "أرخص تسعيرة لونش الإنقاذ في مدينة نصر مع خصم إضافي للعملاء الجدد",
    "إمكانية نقل السيارات من مدينة نصر إلى وكلاء السيارات ومراكز الصيانة المعتمدة"
  ],
  safetyTips: [
    "في حال تعطلت سيارتك في منتصف طريق النصر، لا تحاول عبور الشارع سيراً على الأقدام؛ ابق في السيارة إذا لم تستطع ركنها بجوار الرصيف.",
    "استخدم إشارات التنبيه (الانتظار) فور حدوث العطل، وإذا كنت بالقرب من تقاطعات مكرم عبيد، أرسل موقعك عبر تطبيق واتساب لضمان دقة وصولنا.",
    "إذا تعرضت لحادث لا قدر الله بالقرب من محور NA، تواصل مع المرور أولاً لتأمين المكان، ثم اتصل بنا لسحب السيارة بأمان."
  ],
  faqs: [
    {
      q: "كيف تتغلبون على الزحام المروري في شارع مصطفى النحاس أو عباس العقاد؟",
      a: "نعتمد على نظام تتبع ذكي يحدد موقعك بالضبط، ونرسل إليك أقرب ونش إنقاذ متمركز في الشوارع الجانبية لتجنب الزحام والوصول إليك في غضون 15 دقيقة."
    },
    {
      q: "هل تقومون بإنقاذ السيارات المعطلة في جراجات المولات بمدينة نصر؟",
      a: "نعم، لدينا أوناش صغيرة مخصصة لسحب السيارات من الجراجات ذات الأسقف المنخفضة في المراكز التجارية الكبرى مثل سيتي ستارز أو جنينة مول."
    },
    {
      q: "هل تخدمون مناطق أخرى غير مدينة نصر؟",
      a: "بالتأكيد، نحن ننقل السيارات من مدينة نصر إلى أي مكان آخر سواء داخل القاهرة (مثل التجمع أو المعادي) أو خارجها."
    },
    {
      q: "ما هي طرق الدفع المتاحة لخدمة ونش الإنقاذ؟",
      a: "نوفر طرق دفع مرنة تشمل الدفع النقدي (كاش)، والتحويلات عبر المحافظ الإلكترونية، لتسهيل عملية الدفع بعد إتمام مهمة الإنقاذ بنجاح."
    }
  ],
  seoText: `
    <h2>أقرب ونش سيارات في مدينة نصر لخدمتك</h2>
    <p>تُعد مدينة نصر واحدة من أكبر الأحياء في القاهرة، وتضم تنوعاً هائلاً في الأنشطة التجارية والسكنية. هذا الزخم اليومي يزيد من احتمالية التعرض لأعطال السيارات المفاجئة، سواء كان ذلك بسبب ارتفاع درجة حرارة المحرك في الزحام، أو بسبب تلف الإطارات، أو مشاكل في النظام الكهربائي للسيارة. لذلك، نحن نوفر خدمة طوارئ متكاملة تلبي احتياجاتك في وقت قياسي.</p>

    <h3>خطوات طلب الخدمة عند تعطل سيارتك</h3>
    <p>بمجرد أن تشعر بأي خلل في أداء سيارتك أثناء مرورك من طريق النصر أو ميدان رابعة، قم بتهدئة السرعة وحاول إيقاف السيارة في أقرب منطقة آمنة. الخطوة التالية هي الاتصال برقم ونش انقاذ مدينة نصر المتاح لدينا. سيطلب منك مندوبنا تحديد موقعك ونوع السيارة لضمان إرسال الونش الأنسب (سواء كان ونش سطحة أو ونش مزود بعجل انزلاقي للسيارات الأوتوماتيك التي لا يمكن تحريكها).</p>

    <h3>خدمة المساعدة على الطريق (بدون سحب)</h3>
    <p>ليس كل عطل يتطلب سحب السيارة بالضرورة. في كثير من الأحيان، قد يكون العطل بسيطاً مثل تفريغ شحنة البطارية لأنك نسيت إضاءة السيارة، أو ربما نفاد الوقود. في هذه الحالات، نوفر خدمات المساعدة السريعة في شوارع مدينة نصر، حيث يمكننا إرسال فني متخصص لشحن البطارية أو تغيير الإطار الاحتياطي بسرعة لتعود إلى طريقك دون الحاجة لدفع تكلفة ونش كاملة.</p>

    <h3>تغطية تمتد للأحياء المجاورة</h3>
    <p>نظراً لارتباط مدينة نصر المباشر بالعديد من المناطق الأخرى، فإن خدماتنا تمتد لتغطي المحاور المؤدية إلى مصر الجديدة عبر شارع النزهة أو الثورة. إذا كنت على الأطراف، فيمكنك أيضاً الاستعانة بخدمات <a href="/areas/مصر الجديدة">ونش انقاذ مصر الجديدة</a> أو <a href="/areas/العباسية">ونش انقاذ العباسية</a>. نحن نعمل كشبكة متصلة لضمان ألا تظل عالقاً في أي مكان في شرق القاهرة.</p>
    <p>اختر الاحترافية والأمان، واتصل بنا الآن لإنقاذ سيارتك بأفضل الأسعار في مصر.</p>
  `
};
